var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgControlIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.8894 23.2222L23.9615 25.9588C24.1793 26.0444 24.4282 25.9944 24.5949 25.8299C24.6775 25.749 24.7353 25.6463 24.7617 25.5338C24.7881 25.4212 24.7818 25.3035 24.7438 25.1944L15.8894 6L7.03384 25.1944C6.95606 25.4166 7.01495 25.6655 7.18384 25.8299C7.3505 25.9944 7.59939 26.0444 7.81717 25.9588L15.8894 23.2222Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgControlIcon);
export default __webpack_public_path__ + "static/media/control-icon.f3c147c1e4b5a5a8d180111675f66dfa.svg";
export { ForwardRef as ReactComponent };